/* ================================================== */
/* CHECK BREAKPOINTS
/* ================================================== */

// Init
var breakpointLg, breakpointMd, breakpointSm, breakpointXs;

// Check breakpoints
function checkBreakpoints() {
	breakpointLg = $(window).width() >= 1280;
	breakpointMd = $(window).width() >= 1080 && $(window).width() <= 1279;
	breakpointSm = $(window).width() >= 768 && $(window).width() <= 1079;
	breakpointXs = $(window).width() < 767;
}

$(document).ready(checkBreakpoints());
$(window).on('resize orientationchange', function() {
	checkBreakpoints()
});